export const NETWORK_REQUEST_ERROR_NOTIFY = 'NETWORK_ERROR_MESSAGE_NOTIFY';
export const NETWORK_REQUEST_SUCCESS_NOTIFY = 'NETWORK_SUCCESS_MESSAGE_NOTIFY';
export const NETWORK_REQUEST_MESSAGE_DISMISS = 'NETWORK_REQUEST_MESSAGE_DISMISS';
